import { CsvExportFile } from '@/pages/externals/pos-menu-masters/service';

/**
 * 生成したCSVをブラウザにダウンロードさせます。
 * 再取込できるよう UTF-8・BOM無しで出します（バックエンドの V-001 がBOM付きと
 * UTF-8以外を弾くため）。
 */
export const downloadCsvFiles = (files: CsvExportFile[]): void => {
  files.forEach((file) => {
    const blob = new Blob([file.content], {
      type: 'text/csv;charset=utf-8',
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = file.name;
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};
